export const updateChecker = (interval: number = 300000, onUpdate: () => void) => {
  let lastModified: string | null = null;
  let etag: string | null = null;
  let timer: number | null = null

  async function check() {
    try {
      const response = await fetch('/', {
        method: 'HEAD',
        cache: 'no-cache',
        headers: {
          'Pragma': 'no-cache',
          'Cache-Control': 'no-cache'
        }
      });

      const currentLastModified = response.headers.get('last-modified');
      const currentEtag = response.headers.get('etag');

      if (!lastModified && !etag) {
        lastModified = currentLastModified;
        etag = currentEtag;
        return;
      }

      const hasUpdate = (currentLastModified && currentLastModified !== lastModified) ||
        (currentEtag && currentEtag !== etag);

      lastModified = currentLastModified;
      etag = currentEtag;

      if (hasUpdate) onUpdate?.();
    } catch (error) {
      console.error('check update error:', error);
    }
  }

  return {
    start() {
      this.stop();
      timer = setInterval(check, interval)
    },
    stop() {
      timer && clearInterval(timer)
    },
    forceCheck() {
      check()
    }
  }
}

export const checker = updateChecker(300000, () => {
  alert('Page updated, Please click to refresh.')
  location.reload()
})
